<template>
  <div class="content">
    <div class="content-header">
      <h3>{{t.allWorks.products}}</h3>
    </div>
    <div class="content">
      <template
        v-if="Array.isArray(products_list)&&products_list.length">
        <paginate
          ref="products_paginate"
          name="productsPaginate"
          :list="products_list"
          :per="6"
          :refreshCurrentPage="true"
          class="products-group">
          <div 
            class="item-product"
            v-for="(item,i) in paginated('productsPaginate')"
            :key="i">
            <!-- item -->
            <div class="img">
              <viewer
              :images="viewerImage(item.ImageLink)"
              :options="options">
                <img :src="file(item.ImageLink)" :alt="item.Key">
              </viewer>
            </div>
            <!-- title -->
            <div class="title">
              <span>{{ item.Key }}</span>
            </div>
            <!-- year -->
            <div class="date">
              <span>{{item.Year}}</span>
            </div>
          </div>
        </paginate>
        <paginate-links 
            v-if="products_list.length" for="productsPaginate" 
            :limit="3" 
            :show-step-links="true" 
            :hide-single-page="true"></paginate-links>
      </template>
      <template v-else>
        <div class="spinner" v-if="Array.isArray(products_list)&&!products_list.length">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <!-- request error -->
        <p class="response-error" v-if="products_list==undefined">
          <span>{{ lng == 'tr' ? 'Kayıt bulunamadı' : 'No Records Found' }}</span>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      paginate: ['productsPaginate'],
      options: {
        zoomRatio: 0.5,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1
        }
      }
    };
  },
  computed: {
    ...mapGetters(['products_list', 't', 'file', 'lng'])
  },
  methods: {
    viewerImage(img) {
      let imgs = [];
      imgs.push(this.file(img));
      return imgs;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors';
.products-group {
  display: flex;
  flex-wrap: wrap;
  .item-product {
    padding: 20px;
    width: 33.3333%;
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 15px;
    color: #949195;
    @media screen and (max-width: 500px) {
      width: 50%;
    }
    @media screen and (max-width: 320px) {
      width: 100%;
    }
    .img {
      img {
        border-radius: 50%;
        overflow: hidden;
        width: 100%;
        cursor: pointer;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
      }
    }
    .title {
      margin-top: 10px;
      span {
        display: inline-block;
        border-top: 2px solid #949195;
        border-bottom: 2px solid #949195;
        padding: 3px 10px;
      }
    }
    .date {
      span {
        display: inline-block;
        padding: 5px;
      }
    }
  }
}
</style>
